import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Catering } from './pages/Catering';
import { RequestPage } from './pages/RequestPage';
import { About } from './pages/About';
import { Guide } from './pages/Guide';
import { CityGuide } from './pages/CityGuide';
import { Shop } from './pages/Shop';
import { ShopCheckout } from './pages/ShopCheckout';
import { Discover } from './pages/Discover';
import { PlacePage } from './pages/PlacePage';
import { Join } from './pages/Join';
import { Admin } from './pages/Admin';
import { ContentProvider } from './ContentContext';
import { CartProvider } from './CartContext';
import { ShopProvider } from './ShopContext';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [pathname]);
  return null;
}
export function App() {
  return <ContentProvider data-id="element-0" data-mp="3ihv048vgebg8">
      <CartProvider data-id="element-1" data-mp="3mlj6wpc9h30f">
        <ShopProvider data-id="element-2" data-mp="3mkrdnl64zhdb">
          <BrowserRouter data-id="element-3" data-mp="3mk84asujy1aw">
            <ScrollToTop data-id="element-4" data-mp="3mjg8bgx1m1k3" />
            <div className="flex min-h-screen w-full flex-col bg-papper text-black" data-id="element-5" data-mp="3rcj6y3gog175">
              <Header data-id="element-6" data-mp="3relwkmdx3sbc" />
              <main className="flex-1" data-id="element-7" data-mp="6hp9c27i9cj">
                <Routes data-id="element-8" data-mp="5ghbgghm2z1">
                  <Route path="/" element={<Home data-id="element-10" data-mp="2zld4hgdhhrep" />} data-id="element-9" data-mp="7svdij4jt6t" />
                  <Route path="/catering" element={<Catering data-id="element-12" data-mp="2zn6aquk6q9m6" />} data-id="element-11" data-mp="2zm4vedw4z0yn" />
                  <Route path="/forfragan" element={<RequestPage data-id="element-14" data-mp="33ngf62sbwryx" />} data-id="element-13" data-mp="33mf0zpg0npcz" />
                  <Route path="/om" element={<About data-id="element-16" data-mp="38m1fe27kzbnd" />} data-id="element-15" data-mp="33orkw85c49so" />
                  <Route path="/guide" element={<Guide data-id="element-18" data-mp="38kgocmkh6au9" />} data-id="element-17" data-mp="38kqfwel64q22" />
                  <Route path="/guide/:city" element={<CityGuide data-id="element-20" data-mp="3dlw4q1bpjt6b" />} data-id="element-19" data-mp="3dkl3o99ncziw" />
                  <Route path="/butik" element={<Shop data-id="element-22" data-mp="nvsv37yeytxj" />} data-id="element-21" data-mp="3diruam7ng177" />
                  <Route path="/kassa" element={<ShopCheckout data-id="element-24" data-mp="nvar1p5ifbf2" />} data-id="element-23" data-mp="nuhh6fb985sp" />
                  <Route path="/upptack" element={<Discover data-id="element-26" data-mp="stko65asom3b" />} data-id="element-25" data-mp="sudk0b87tr6o" />
                  <Route path="/plats/:slug" element={<PlacePage data-id="element-28" data-mp="36877lhgoowl" />} data-id="element-27" data-mp="ssstcwp0use3" />
                  <Route path="/bli-en-del" element={<Join data-id="element-30" data-mp="38kw6ilmzzj5" />} data-id="element-29" data-mp="356ttacz3qbp" />
                  <Route path="/admin" element={<Admin data-id="element-32" data-mp="3ubri4mbn8k51" />} data-id="element-31" data-mp="3ud1en72ulk9k" />
                </Routes>
              </main>
              <Footer data-id="element-33" data-mp="d57h17dyqql6" />
            </div>
          </BrowserRouter>
        </ShopProvider>
      </CartProvider>
    </ContentProvider>;
}